import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";

import { BannerData } from "@/app/api/sales-event/banner/route";

export const useEventBanner = () => {
  const [bannerInfo, setBannerInfo] = useState<BannerData | null>(null);
  const [showBanner, setShowBanner] = useState(false);

  // Fetch banner data from JSON file
  useEffect(() => {
    fetch("/sales-event/banner.json")
      .then((res) => res.json())
      .then((data) => {
        setBannerInfo(data);
      })
      .catch((err) => console.error("Failed to load banner data:", err));
  }, []);

  // Determine if banner should be shown
  const shouldShowBanner = useCallback(() => {
    // Early returns for obvious cases
    if (!bannerInfo) return false;

    const today = dayjs();
    const startDate = dayjs(bannerInfo.startDate).startOf("day");
    const endDate = dayjs(bannerInfo.endDate).endOf("day");

    // Check if current date is within the event period
    const isWithinEventPeriod =
      today.isAfter(startDate) && today.isBefore(endDate);

    return isWithinEventPeriod;
  }, [bannerInfo]);

  // Set banner visibility
  useEffect(() => {
    if (bannerInfo && shouldShowBanner()) {
      setShowBanner(true);
    }
  }, [bannerInfo, shouldShowBanner]);

  return { bannerInfo, showBanner, setShowBanner };
};
